import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PageMeta } from 'models/stateInterface';

import { Maybe } from 'models/types';
import { ProductBookingResponse, ProductBookingliceInterface } from './ProductBooking.interface';

const initialState: ProductBookingliceInterface = {
  loading: true,
  data: [],
  meta: null,
  error: null,
};

export const productBookingSlice = createSlice({
  name: 'productBooking',
  initialState,
  reducers: {
    setProductBooking: (
      state,
      action: PayloadAction<{ productBooking: ProductBookingResponse[]; pageMeta: Maybe<PageMeta> }>
    ) => {
      state.data = action.payload.productBooking;
      state.loading = false;
      state.error = null;
      state.meta = action.payload.pageMeta;
    },
    setProductBookingLoading(state) {
      state.loading = true;
    },
    setProductBookingError(state, action: PayloadAction<any>) {
      state.data = [];
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setProductBooking, setProductBookingLoading, setProductBookingError } = productBookingSlice.actions;

export const productBookingLoadingState = (state: RootState) => state.ProductBooking.loading;
export const productBookingState = (state: RootState) => state.ProductBooking.data;
export const productBookingmetaState = (state: RootState) => state.ProductBooking.meta;
export default productBookingSlice.reducer;
